import { getD2CRefundPolicyRuleText } from '@orcar/common';
import {
  isMobileAtom,
  ListStyle,
  useGetRefundPolicies,
  useRecoil,
} from '@orcar/common-d2c';
import { Fragment } from 'react';
import styled from 'styled-components';

type CancellationFeeProps = {
  padding?: string;
  hasTitle?: boolean;
};

const CancellationFee = ({
  padding,
  hasTitle = true,
}: CancellationFeeProps) => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);
  const { data } = useGetRefundPolicies();

  return (
    <Wrapper padding={padding}>
      {hasTitle && (
        <SectionTitle isMobile={isMobile}>예약 취소 수수료</SectionTitle>
      )}
      <ContentWrapper>
        {data?.data.map((refundPolicy) => (
          <Fragment key={refundPolicy.id}>
            <Text fontWeight={600}>{refundPolicy.name}</Text>
            <ListWrapper isMobile={isMobile}>
              {refundPolicy.rules.map((rule, idx) => (
                <li key={idx}>{getD2CRefundPolicyRuleText(rule)}</li>
              ))}
            </ListWrapper>
          </Fragment>
        ))}
        <Text fontWeight={600}>성수기 안내</Text>
        <ListWrapper isMobile={isMobile}>
          <li>25~26 연말연휴(25년12/29~26년1/1)</li>
          <li>설날 연휴(2/13~2/17)</li>
          <li>삼일절 연휴(2/27~3/2)</li>
          <li>근로자/어린이날 연휴 (5/1~5/5)</li>
          <li>부처님오신날 연휴 (5/22~5/25)</li>
          <li>지방선거/현충일 연휴(6/2~6/6)</li>
          <li>여름성수기(7/24~8/10)</li>
          <li>광복절 연휴 (8/14~8/17)</li>
          <li>추석 연휴(9/23~9/26)</li>
          <li>개천절 연휴(10/3~10/5)</li>
          <li>한글날 연휴(10/9~10/11)</li>
          <li>26~27 성탄 및 연말연휴(26년12/24~27년1/1)</li>
        </ListWrapper>
        <Text fontWeight={600}>차종 변경</Text>
        <Text>
          차종 변경에 대한 수수료 안내입니다. (변경에 대한 문의는 예약실로
          문의해주시기 바랍니다.)
        </Text>
        <Text>
          처음 예약한 차종에 따라 등급별로 수수료가 발생합니다. (신규 예약하고자
          하는 차종 상관없음)
        </Text>
        <Text>차량 렌트 요금 차액은 별도로 청구됩니다.</Text>
        <ListWrapper isMobile={isMobile}>
          <li>경차/소형: 20,000원</li>
          <li>준중형/중형: 30,000원</li>
          <li>고급/SUV: 40,000원</li>
          <li>수입/승합: 50,000원</li>
          <li>슈퍼카: 불가 (24시간 금액 청구)</li>
        </ListWrapper>
        <Text>
          차종 변경에 대해서 위 수수료는 기본적으로 발생되고 차량 렌트 요금의
          차액은 추가로 청구됩니다.
        </Text>
        <Text>
          위 수수료는 차량 출고전 기준 금액으로, 차량 출고 후 변경에 대한 문의는
          수수료도 상이하고 렌트카 상황에 따라 달라지므로 별도로 문의해주시기
          바랍니다.
        </Text>
      </ContentWrapper>
    </Wrapper>
  );
};

export default CancellationFee;

const Wrapper = styled.div<{ padding?: string; gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? gap : 0)}px;
  padding: ${({ padding }) => (padding ? padding : '0px')};

  & li {
    ${ListStyle}
  }
`;

const ContentWrapper = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? gap : 0)}px;
`;

const SectionTitle = styled.p<{
  isMobile: boolean;
  margin?: string;
  fontSize?: string;
  fontWeight?: number;
}>`
  margin: ${({ margin }) => (margin ? margin : '0 0 20px 0')};
  ${({ isMobile, theme }) => (isMobile ? theme.FONT.H4 : theme.FONT.H5)};

  font-size: ${({ fontSize }) => fontSize && fontSize};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
`;

const ListWrapper = styled.ul<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: ${({ isMobile }) => (isMobile ? '24px' : '27px')};
  margin-bottom: 20px;
`;

const Text = styled.span<{
  fontWeight?: number;
  fontSize?: string;
}>`
margin-bottom: 10px;
  color: ${({ theme }) => theme.COLOR.GREY_01}};
  ${({ theme }) => theme.NEW_FONT.B1};
  font-weight: ${({ fontWeight }) => fontWeight && fontWeight};
  font-size: ${({ fontSize }) => fontSize && fontSize};
  line-height: 19px;
`;
